import { Box, Container, Typography, Button, useTheme } from "@mui/material";
import { NavLink } from "react-router-dom";
import { DescriptiveLogo } from "../logo";
import ServiceBackgroundImage from "../../assets/img/jpg/2148039979.jpg";
import ServicesList from "../../components/services/services";

export default function AboutComponent() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Content */}
      <Box sx={{ width: "100%" }}>
        {/* First Section - Who We Are */}
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 6,
              alignItems: "center",
              mb: 8,
              py: { xs: 4, md: 8 },
            }}
          >
            {/* Content Section */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", md: "flex-start" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  color: theme.palette.text.primary,
                  mb: 4,
                }}
              >
                Quem Somos
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: theme.palette.text.secondary,
                  mb: 4,
                  lineHeight: 1.8,
                  fontSize: "1.1rem",
                  maxWidth: "600px",
                }}
              >
                Na Clima Tropical, somos especialistas em manutenção, reparação
                e montagem de sistemas de ar condicionado, tanto para
                residências quanto para veículos. Com anos de experiência no
                setor, nossa missão é garantir o conforto e a satisfação dos
                nossos clientes através de serviços de alta qualidade e um
                atendimento personalizado. Nós nos comprometemos a oferecer
                soluções eficientes e eficazes, adaptadas às necessidades
                específicas de cada cliente.
              </Typography>

              <Button
                component={NavLink}
                to="/about"
                variant="contained"
                size="medium"
                sx={{
                  fontWeight: "bold",
                  px: 2,
                  py: 1,
                  fontSize: "1rem",
                  backgroundColor: theme.palette.primary.main,
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[6],
                  },
                  transition: "all 0.3s ease-in-out",
                }}
              >
                Saiba mais
              </Button>
            </Box>

            {/* Logo Section */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: { xs: 4, md: 0 },
              }}
            >
              <DescriptiveLogo height={20} />
            </Box>
          </Box>
        </Container>

        {/* Services Section with Background Image */}
        <Box
          sx={{
            position: "relative",
            backgroundImage: `url(${ServiceBackgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            py: { xs: 6, md: 10 },
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.72)",
              backdropFilter: "blur(2px)",
            },
          }}
        >
          <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                mb: 6,
                color: theme.palette.text.primary,
              }}
            >
              Nossos Serviços
            </Typography>
            <ServicesList />
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
